import { produceNameId, isNameValid } from '../helpers.js';
import address from './address.js';
import { Encoding } from '../../../utils/encoder.js';
const addressName = address(Encoding.Name);
export default {
  ...addressName,
  /**
   * @param value - AENS name ID
   */
  serialize(value) {
    return addressName.serialize(isNameValid(value) ? produceNameId(value) : value);
  }
};
//# sourceMappingURL=name-id.js.map